import { sessionActions } from '../reducer/session';
import { uploadActions } from '../reducer/uploadProgress';

// Actions from SessionReducer
export const {
  loadingStart,
  loadingStop,
  login,
  logout,
  toggleSideNav,
  toggleMenu,
  loadSessionFromLocal
} = sessionActions;

export const { setUploadProgress } = uploadActions;
